import React from 'react';
import PropTypes from 'prop-types';
import Flex from '../../../shared/components/basic/Flex';
import ColoracionBar from './ColoracionBar';
import IndicesBar from './IndicesBar';

export default function IndicesYColoracionBar({
  handleChangeIndices,
  handleChangeColoracion,
  indices,
  indicesPreSeleccionados,
  colores,
  lentesGamasColores,
  loadingColores,
  loadingIndices,
  drawColoracion,
  drawIndices,
  trabajaConColores,
  modo,
}) {
  return (
    <Flex alignItems="center">
      {drawIndices && <IndicesBar hideColoracion={!drawColoracion} indices={indices} indicesPreSeleccionados={indicesPreSeleccionados} handleChangeIndices={handleChangeIndices} loadingIndices={loadingIndices} />}
      { drawColoracion
      && (
      <ColoracionBar
        colores={colores}
        trabajaConColores={trabajaConColores}
        lentesGamasColores={lentesGamasColores}
        handleChangeColoracion={handleChangeColoracion}
        loadingColores={loadingColores}
        modo={modo}
      />
      )}
    </Flex>
  );
}

IndicesYColoracionBar.propTypes = {
  handleChangeIndices: PropTypes.func,
  handleChangeColoracion: PropTypes.func,
  indices: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  indicesPreSeleccionados: PropTypes.arrayOf(PropTypes.shape({})),
  lentesGamasColores: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  colores: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    empresaId: PropTypes.number,
    esCliente: PropTypes.number,
    nombre: PropTypes.string,
    gamaColor: PropTypes.number,
    activa: PropTypes.number,
    fechaModificacion: PropTypes.string,
  })).isRequired,
  drawColoracion: PropTypes.bool,
  drawIndices: PropTypes.bool,
  loadingColores: PropTypes.bool,
  loadingIndices: PropTypes.bool,
  trabajaConColores: PropTypes.bool,
  modo: PropTypes.string,
};
IndicesYColoracionBar.defaultProps = {
  handleChangeIndices: () => {},
  handleChangeColoracion: () => {},
  indicesPreSeleccionados: [],
  loadingColores: false,
  loadingIndices: false,
  drawColoracion: true,
  drawIndices: false,
  trabajaConColores: false,
  modo: 'consulta',
};
